//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import makeClasses from '~/helpers/makeClasses';
import BaseIcon from '@/components/BaseIcon';

const THEMES = {
    dark: 'dark',
    light: 'light'
};

const useClasses = makeClasses(() => ({
    link: ({ theme }) => ({
        'text-white': theme === THEMES.light,
        'text-gray-650': theme === THEMES.dark
    }),
    text: ({ theme }) => ({
        'text-white text-opacity-50': theme === THEMES.light,
        'text-gray-700 text-opacity-40': theme === THEMES.dark
    })
}));

export default {
    components: {
        BaseIcon
    },
    props: {
        items: {
            type: Array,
            required: true
        },
        theme: {
            default: THEMES.light,
            validator(value) {
                return Object.keys(THEMES).includes(value);
            }
        }
    },
    computed: {
        classes() {
            return useClasses({
                theme: this.theme
            });
        }
    },
    methods: {
        isRoute(route) {
            return route.name || route.path;
        }
    }
};
